import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import AnimatedBackground from "./components/animatedBackground";
import Footer from "./components/footer";

export default class TermsOfService extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Terms of Use";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="short"
					title="Terms of Service"
					description=""
					images={["alpine-ski-suits.png"]}
				/>

				<SubNavigation location={this.props.location} refs={this.refs} />

				<div className="qs-b" ref="material2">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row">
							<div className="col content green">
								<h2 className="title">QwixSkinz Website Disclaimer Notice</h2>
								<br />
								<h3 className="title">About using this Website</h3>
								<p className="lead">
									By using this website you are accepting all the terms of this
									disclaimer notice. If you do not agree with anything in this
									notice you should not use this website.
								</p>
								<br />
								<br />

								<h3 className="title">Warranties and Liability</h3>

								<p>
									While every effort is made to ensure that the content of this
									website is accurate, the website is provided "as is" and
									QwixSkinz makes no representations or warranties in relation
									to the accuracy or completeness of the information found on
									it. While the content of this site is provided in good faith,
									we do not warrant that the information will be kept up to
									date, be true and not misleading, or that this site will
									always (or ever) be available for use.
								</p>
								<p>
									We do not warrant that the servers that make this website
									available will be error, virus or bug free and you accept that
									it is your responsibility to make adequate provision for
									protection against such threats. We recommend scanning any
									files before downloading.
								</p>
								<p>
									Nothing on this website should be taken to constitute
									professional advice or a formal recommendation and we exclude
									all representations and warranties relating to the content and
									use of this site.
								</p>
								<p>
									In no event will QwixSkinz be liable for any incidental,
									indirect, consequential or special damages of any kind, or any
									damages whatsoever, including, without limitation, those
									resulting from loss of profit, loss of contracts, goodwill,
									data, information, income, anticipated savings or business
									relationships, whether or not advised of the possibility of
									such damage, arising out of or in connection with the use of
									this website or any linked websites.
								</p>

								<br />
								<br />
								<h3 className="title">Exceptions</h3>
								<p>
									Nothing in this disclaimer notice excludes or limits any
									warranty implied by law for death, fraud, personal injury
									through negligence, or anything else that it would not be
									lawful for QwixSkinz to exclude.
								</p>

								<br />
								<br />
								<h3 className="title">License to use this Website</h3>
								<p>
									By using this website you agree to the exclusions and
									limitations of liability stated above and accept them as
									reasonable. Do not use this website if you do not agree that
									they are reasonable.
								</p>
								<p>
									If any of the points in this disclaimer notice are found to be
									unenforceable under applicable law, that will have no bearing
									on the enforceability of the rest of the disclaimer notice.
								</p>
								<p>
									Material on this website, including text and images, is
									protected by copyright law and is copyright to QwixSkinz
									unless credited otherwise. It may not be copied, reproduced,
									republished, downloaded, posted, broadcast or transmitted in
									any way except for your own personal, non-commercial use.
								</p>
								<p>
									Prior written consent of the copyright holder must be obtained
									for any other use of material.
								</p>
								<p>
									No part of this site may be distributed or copied for any
									commercial purpose or financial gain.
								</p>
								<p>
									All intellectual property rights in relation to this website
									are reserved and owned by QwixSkinz.
								</p>

								<br />
								<br />
								<h3 className="title">Links to Other Websites and Products</h3>
								<p>
									Links to other websites are provided for the convenience of
									users. We are unable to provide any warranty regarding the
									accuracy or completeness of the content of such sites, or the
									reliability, quality or effectiveness of any products provided
									through external websites. A link to an external site does not
									imply an endorsement of the views, information or products
									provided or held by such websites.
								</p>

								<br />
								<br />
								<h3 className="title">Variations</h3>
								<p>
									We reserve the right to revise and amend this disclaimer
									notice from time to time and any revised version will be
									deemed to be applicable from the first date of publication on
									this website.
								</p>

								<br />
								<br />
								<h3 className="title">About Us</h3>
								<p>This website is owned by QwixSkins XXX-XXX-XXXX</p>
							</div>
						</div>
					</div>
				</div>

				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
